<template>
  <div>
    <div id="user-manage" class="screenshots">
      <div class="row">
        <div class="col-md-12">
          <router-link class="ui-back-action" :to="{ name: 'List Synchronization' }">
            <i class="fas fa-chevron-left"></i>
            {{ $t("global.back") }}
          </router-link>
        </div>
      </div>
      <br>
      <header class="d-flex justify-content-between">
        <h1>{{ fraseTitulo }} usuario</h1>
        <button @click="guardarPermisos" v-if="!disabled" :disabled="validationApiData"
          :class="!validationApiData ? 'new-btn' : 'new-btn diasabledButton'">+ {{ $t('users.adminUser.save')
          }}</button>

      </header>
      <br>
      <h5>{{ $t('users.adminUser.date') }}</h5>
      <br>
      <div v-if="!idUser">
        <div>
          <input :disabled="apiData.controlNumber != ''" :class="apiData.controlNumber == '' ? 'p-2' : 'p-2 diasabled'"
            type="text" placeholder="Buscar..." @input="getUsersFilter" />
        </div>
        <br>
        <br>
        <v-client-table :columns="table_options.columns" :options="table_options.options" :data="newsList">

          <template v-slot:actions="props">
            <div class="actions">

              <button v-if="addUser" class="button-table" @click="onClick({action:'checkUser',data:props.row})">Agregar</button>
              <button v-if="!addUser" class="button-table" @click="onClick({action:'delete',data:props.row})">Quitar</button>
              <!--<span class="icons-black" @click="()=>{}">
                <i class="far fa-eye"></i>
              </span>-->
            </div>
          </template>
        </v-client-table>

      </div>
      <div v-if="idUser">
        <b-row cols-lg="12">
          <b-col sm="4" class="noEditable">
            <label class="normal">Nombre</label>
            <input class="form-control " type="text" disabled v-model="apiData.firstName" />
          </b-col>

          <b-col sm="4" class="noEditable">
            <label class="normal">Apellido</label>
            <input class="form-control " type="text" disabled v-model="apiData.lastName" />
          </b-col>
          <b-col sm="3" class="noEditable">
            <label class="normal">No. control</label>
            <input class="form-control " type="text" disabled v-model="apiData.controlNumber" />
          </b-col>

        </b-row>
        <br>
        <br>
        <br>
      </div>


      <br>
      <br>
      <h5>Sincronización de credenciales</h5>
      <br>
      <div class=" flex " id="accordionExample">
        <div v-for="(data, indexData) in arrayData" class=" flexData">
          <div v-for="(datas, index) in data" class="mb accordion-item">

            <div class="form-check accordion-header" :id="`headingOne${datas.id}`">

              <input class="form-check-input" type="checkbox" value="" :checked="datas.check"
                @change="onChangeCheck($event, datas.permission)" :disabled="disabled">
              <label class="form-check-label">
                {{ datas.name }}

              </label>
            </div>


          </div>
        </div>
      </div>
      <!-- <button @click="showAlert = !showAlert">Show alert: {{showAlert}}</button> -->
    </div>

    <div class="modal fade  modal-dialog-center-data" id="exampleModal" tabindex="-1" aria-labelledby=""
      aria-hidden="true" ref="myErrorModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">¿Deseas editar este usuario?
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div>
              <p>El usuario ya cuenta con permisos registrados, por lo cual no es posible crear un nuevo
                registro ,pero puedes editar sus accesos</p>
            </div>
          </div>
          <div class="modal-footer">
            <slot name="footer"></slot>
            <b-button class="btn btn-light float-right" @click="closeEditStops()">
              {{ $t("bookingTransport.cancel") }}
            </b-button>
            <b-button class="btn btn-dark float-right" @click="editModal()">
              Editar
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import API_SERVICE_USERS from "@/lib/api/userManagement";
import API_SERVICE from "@/lib/api/Users.js";
import { ClientTable } from "vue-tables-2";
export default {
  name: "UserManage",
  components: {
    ClientTable
  },

  data() {
    return {
      addUser:true,
      newsList: [],
      myError: null,
      apiUsers: new API_SERVICE_USERS(),
      api: new API_SERVICE(),

      apiData: {
        controlNumber: "",
        email: "",
        userRole: "",
        firstName: "",
        lastName: "",
        accessList: []
      },

      buttons: {
        titleColumn: "Acciones",
        buttons: [
          {
            color: "ui-action-button ui-action-button--inversed ui-action-button--flat",
            text: "Agregar",
            action: "checkUser"
          }
        ]
      },

      fraseTitulo: "Agregar",
      idUser: null,
      permisosUsuario: {},
      datosPermisos: [],
      arrayData: [],
      accessList: {},
      disabled: false,
      sendEmail: false,
      temporalData: {},
    };
  },

  computed: {
    validationApiData() {
      if (
        this.apiData.controlNumber === "" ||
        this.apiData.firstName === "" ||
        this.apiData.lastName === ""
      ) {
        return true;
      }
      return false;
    },
     table_options: function () {
      return {

        columns: [
         "controlNumber", "name", "lastName", "mothersLastName", "companyEmail","actions"
        ],
        options: {
          filterByColumn: true,
          filterable: this.table_filters,
          texts: {
            filter: `${this.$t("components.vue_tables.filter")}:`,
            filterPlaceholder: this.$t("components.vue_tables.filter_ph")
          },
          headings: {
            controlNumber:"Número de control",
            name:"Nombre",
            mothersLastName:"Apellido Materno", 
            lastName:"Apellido Paterno",
            companyEmail:"Email",
            actions: "Acciones"
          },
          sortable: [
            "id",
            "name"
          ],
          customSorting: {
            report: function (ascending) {
              return function (a, b) {
                if (ascending) {
                  return !a.hasCommentsReported ? 1 : -1;
                }
                return a.hasCommentsReported ? 1 : -1;
              };
            }
          },
          filterable: [],
          sortIcon: {
            base: "fas",
            up: "fa-sort-up",
            down: "fa-sort-down",
            is: "fa-sort"
          },
          columnsClasses: {
            title: "title-column",
            report: "report-column",
            actions: "actions-column",
            updated_at: "updatedAt-column"
          },
          resizableColumns: false
        }
      };
    },
  },

  async mounted() {
    this.$store.commit("global/SET_LOADING", true);

   

    const resp = await this.apiUsers.getListpermisions();

    this.myError = new Modal(this.$refs.myErrorModal);

    this.idUser = this.$route.params.id || null;
    const typeParamas = this.$route.params.type || null;

    this.fraseTitulo = typeParamas
      ? "Ver"
      : this.idUser
        ? "Editar"
        : "Agregar";

    resp.items.forEach(item => {
      item.check = false;
    });

    if (typeParamas) {
      this.disabled = true;
    }

    if (this.idUser) {
      const respData = await this.apiUsers.getUserDetailsV3(this.idUser);

      this.apiData.controlNumber = respData.controlNumber;
      this.apiData.email = "----";
      this.apiData.firstName = respData.name;
      this.apiData.lastName = respData.lastName;

      resp.items.forEach(item => {
        item.check = respData.permissions[item.permission];
      });
    }

    this.arrayData = resp.items.map(item => [item]);

    this.$store.commit("global/SET_LOADING", false);
  },

  methods: {
    async getUsersFilter(e) {
      this.$store.commit("global/SET_LOADING", true);

      const object = {
        page: 0,
        limit: 10,
        query: {
          controlNumber: e.target.value
        }
      };

      try {
        if (e.target.value) {
          const resp = await this.api.getUsers(object);
          this.newsList=resp.data || [];
        } else {
          this.newsList=[];
        }
      } catch (error) {
        throw error;
      }

      this.$store.commit("global/SET_LOADING", false);
    },

    onChangeCheck(event, permission) {
      this.permisosUsuario = {
        permission: permission,
        isEnabled: event.target.checked
      };
    },

    async guardarPermisos() {
      this.$store.commit("global/SET_LOADING", true);

      try {
        await this.apiUsers.createEditUserV3(
          this.apiData.controlNumber,
          this.permisosUsuario
        );

        this.$store.commit("global/SET_ALERT", {
          msg: "Permisos guardados correctamente",
          show: true,
          type: "success"
        });

        setTimeout(() => {
          this.$router.push({ name: "List Synchronization" });
        }, 3000);
      } catch (error) {
        this.$store.commit("global/SET_ALERT", {
          msg:
            error.response.data.message ||
            "Error al guardar la información",
          show: true,
          type: "error"
        });
      }

      this.$store.commit("global/SET_LOADING", false);
    },

    closeEditStops() {
      this.myError.hide();
    },

    editModal() {
      this.myError.hide();

      this.$router.push({
        name: "Edit Synchronization",
        params: {
          id: this.temporalData.controlNumber
        }
      });

      setTimeout(() => {
        window.location.reload();
      }, 2000);
    },

    async onClick(e) {
      if (e.action === "checkUser") {
        this.addUser=false;
        this.$store.commit("global/SET_LOADING", true);

        let accesos = [];
        let resp = {};

        try {
          resp = await this.apiUsers.getUserDetailsV3(
            e.data.controlNumber
          );
          accesos = resp.accessList || [];
        } catch (error) { }

        this.$store.commit("global/SET_LOADING", false);

        if (accesos.length > 0 || resp.controlNumber) {
          this.temporalData = e.data;
          this.myError.show();
          this.resetForm();
        } else {
          this.buttons.buttons[0] = {
            color:
              "ui-action-button ui-action-button--inversed ui-action-button--flat",
            text: "Quitar",
            action: "deleteUser"
          };

          this.apiData.controlNumber = e.data.controlNumber;
          this.apiData.email =e.data.companyEmail.toLowerCase() || "";
          this.apiData.firstName = e.data.name;
          this.apiData.lastName = e.data.lastName;

        }
        this.newsList=[e.data];
      } else {
        this.addUser=true;
        this.resetForm();
        this.newsList=[];
      }
    },

    resetForm() {
      this.buttons.buttons[0] = {
        color:
          "ui-action-button ui-action-button--inversed ui-action-button--flat",
        text: "Agregar",
        action: "checkUser"
      };

      this.apiData = {
        controlNumber: "",
        email: "",
        userRole: "",
        firstName: "",
        lastName: "",
        accessList: []
      };

    }
  }
};
</script>

<style lang="scss" scoped>
.screenshots {
  height: max-content;
  max-width: 100%;
  width: 100%;
  padding-bottom: 50px !important;
}

.noEditable {
  background-color: #e4e7ea !important;
  font-stretch: normal;
  font-style: normal;
  font-variant: normal;
  font-weight: bold;
  letter-spacing: normal;
  line-height: normal;
  text-decoration: none;
  text-transform: none;
  margin-right: 20px;
}

.normal {
  font-weight: 100;
  font-size: 14px;
}

.new-btn {
  align-self: center;
  background-color: $black;
  color: $white;
  border: 1px solid $black;
  border-radius: 0;
  padding: 0.5rem 2rem;
  margin: 1rem 0;
}

.form-check-input[type=checkbox] {
  border: 1px solid black;
  border-radius: 0.25em;
}

.form-check-input {
  border: 1px solid black;
}

.mr {
  margin-left: 20px;
}

.mb {
  margin-bottom: 13px;
}

.mb-child {
  margin-top: 20px;
}

.flex {
  display: flex;
  flex-direction: row;
}

.flexData {
  flex: 0 0 20%;
}

.table {
  background-color: gray !important;
  --bs-table-bg: #f2f2f2 !important;
  font-weight: 200;
}

th {
  font-weight: 100 !important;
}

.black {
  background-color: black;
  color: white;
}

.accordion-item,
.accordion,
.accordion-header {
  background-color: transparent !important;
  border: none;


}

.subItem {
  margin-left: 15px;
  cursor: pointer;
}

.diasabled {
  border-radius: 2px;
  background: #e1e1e1 !important;
}

.diasabledButton {
  background-color: rgb(102, 101, 101);
}
.button-table{
  padding: 5px 15px;
}
</style>